var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-view",attrs:{"id":"admin-real-estate-development-create"}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"md":"12"}},[_c('real-estate-development-create-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }